import { useCallback, useEffect, useState } from "react"
import { useUserAuthStore } from "../../stores/global/userAuth";
import { GridColumnVisibilityModel } from "@mui/x-data-grid-pro";
import { useDependencyInjection } from "../../config/di/dependency_injection_context";

/**
 * useColumnSelectionConfig
 */

type Props = {
  tabela: string;
};

export const useColumnSelectionConfig = ({
  tabela,
}: Props): [
    GridColumnVisibilityModel | undefined,
    (tabelas: GridColumnVisibilityModel) => void,
  ] => {
  const {
    commons: {
      saveUsuarioTableSchemeUseCase,
    }
  } = useDependencyInjection();

  const { idUsuario } = useUserAuthStore();
  const [selectedColumns, setSelectedColumns] = useState<GridColumnVisibilityModel>();

  useEffect(() => {
    let userColumnData = window.localStorage.getItem(`${idUsuario}_columns`) as any;
    if (userColumnData !== null) {
      userColumnData = JSON.parse(userColumnData);
      const columnData = userColumnData[tabela];
      if (columnData !== undefined && columnData !== null) {
        const loadedColumns = columnData as GridColumnVisibilityModel;
        setSelectedColumns(prev => ({ ...prev, ...loadedColumns }));
      } else {
        setSelectedColumns(undefined);
      }
    }
  }, [
    idUsuario,
    tabela,
  ]);

  const handleSaveSelectedColumns = useCallback((tabelas: GridColumnVisibilityModel) => {
    try {
      let userColumnData = window.localStorage.getItem(`${idUsuario}_columns`) as any;
      if (userColumnData !== null) {
        userColumnData = JSON.parse(userColumnData);
        setSelectedColumns(tabelas);
        userColumnData[tabela] = tabelas;
        setTimeout(() => window.localStorage.setItem(`${idUsuario}_columns`, JSON.stringify(userColumnData)), 0);
        saveUsuarioTableSchemeUseCase.saveUsuarioTableScheme(idUsuario, JSON.stringify(userColumnData));
      } else {
        userColumnData = {};
        setSelectedColumns(tabelas);
        userColumnData[tabela] = tabelas;
        setTimeout(() => window.localStorage.setItem(`${idUsuario}_columns`, JSON.stringify(userColumnData)), 0);
        saveUsuarioTableSchemeUseCase.saveUsuarioTableScheme(idUsuario, JSON.stringify(userColumnData));
      }
    } catch (e: unknown) {
      console.log(e);
    }
  }, [
    idUsuario,
    saveUsuarioTableSchemeUseCase,
    tabela,
  ]);

  return [selectedColumns, handleSaveSelectedColumns];
}